import React from 'react'
import styled from 'styled-components'
import { ReactComponent as SuccessIcon } from '../../assets/email/success.svg'
import Head from 'next/head'

const PageWrapper = styled.div`
  width: 100vw;
  height: 100vh;
  box-sizing: border-box;
  background: #f5f5f5;
  display: flex;
  justify-content: center;
  padding-top: 120px;

  @media (max-width: 1100px) {
    padding-top: 37px;
  }
`

export const PageContent = styled.div`
  width: 1048px;
  height: 584px;
  flex-shrink: 0;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  @media (max-width: 1100px) {
    width: 90vw;
    height: 80vh;
  }
`

export const Title = styled.h1`
  color: #000;
  text-align: center;
  font-family: Helvetica Neue;
  font-size: 36px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-top: 35px;
  margin-bottom: 32px;

  @media (max-width: 1100px) {
    font-size: 20px;
  }
`

export const Link = styled.a`
  display: flex;
  width: 178px;
  height: 50px;
  justify-content: center;
  align-items: center;
  color: white;
  border-radius: 37px;
  background: #ff5e6d;
  font-size: 16px;
  font-weight: 700;
`

export const VerifyEmailSuccessPage = () => {
  return (
    <>
      <Head>
        <title>Password Updated – DecorMatters</title>
      </Head>
      <PageWrapper>
        <PageContent>
          <SuccessIcon />
          <Title>Successfully updated your password!</Title>
          <Link href="https://decormatters.app.link/download-app">
            Back to App
          </Link>
        </PageContent>
      </PageWrapper>
    </>
  )
}

export default VerifyEmailSuccessPage

export async function getServerSideProps({ query }) {
  try {
    return {
      props: {
        inApp: true,
        disableModals: true,
        disableOverscroll: true
      }
    }
  } catch (error) {
    return {
      props: {}
    }
  }
}
